import { render } from "./LegacyThresholdAchievementReportSettings.vue?vue&type=template&id=4ca8bd8b"
import script from "./LegacyThresholdAchievementReportSettings.vue?vue&type=script&lang=js"
export * from "./LegacyThresholdAchievementReportSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__